/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

export type FileID = string;

export class File {
	id: FileID = ''

	isFeatured?: boolean

	url?: string
}